import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { authApi } from "../service/authApi";
import { ApiError } from "../service/apiClient";
import styles from "./AccountPage.module.scss";
const PASSWORD_RULES = [
    { test: (v) => v.length >= 10, label: "Minst 10 tecken" },
    { test: (v) => /[A-Z]/.test(v), label: "Minst en stor bokstav" },
    { test: (v) => /[a-z]/.test(v), label: "Minst en liten bokstav" },
    { test: (v) => /[0-9]/.test(v), label: "Minst en siffra" },
];
export function AccountPage() {
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    async function handleSubmit(event) {
        event.preventDefault();
        setError(null);
        setSuccess(false);
        if (newPassword !== confirmPassword) {
            setError("De nya lösenorden matchar inte.");
            return;
        }
        if (!PASSWORD_RULES.every((rule) => rule.test(newPassword))) {
            setError("Det nya lösenordet uppfyller inte kraven nedan.");
            return;
        }
        setSubmitting(true);
        try {
            await authApi.changePassword(currentPassword, newPassword);
            setSuccess(true);
            setCurrentPassword("");
            setNewPassword("");
            setConfirmPassword("");
        }
        catch (err) {
            setError(err instanceof ApiError ? err.message : "Kunde inte byta lösenord.");
        }
        finally {
            setSubmitting(false);
        }
    }
    return (_jsx("div", { className: styles.page, children: _jsxs("form", { className: styles.card, onSubmit: handleSubmit, children: [_jsx("h1", { children: "Byt l\u00F6senord" }), _jsxs("label", { children: ["Nuvarande l\u00F6senord", _jsx("input", { type: "password", value: currentPassword, onChange: (e) => setCurrentPassword(e.target.value), required: true, autoFocus: true })] }), _jsxs("label", { children: ["Nytt l\u00F6senord", _jsx("input", { type: "password", value: newPassword, onChange: (e) => setNewPassword(e.target.value), required: true })] }), _jsxs("label", { children: ["Bekr\u00E4fta nytt l\u00F6senord", _jsx("input", { type: "password", value: confirmPassword, onChange: (e) => setConfirmPassword(e.target.value), required: true })] }), _jsx("ul", { className: styles.rules, children: PASSWORD_RULES.map((rule) => (_jsx("li", { className: rule.test(newPassword) ? styles.ruleMet : undefined, children: rule.label }, rule.label))) }), error && _jsx("p", { className: styles.error, children: error }), success && _jsx("p", { className: styles.success, children: "L\u00F6senordet har bytts." }), _jsx("button", { type: "submit", disabled: submitting, children: submitting ? "Byter lösenord…" : "Byt lösenord" })] }) }));
}
